import {showErrorToast} from '@utils/Toast';
import {handleErrorResponse} from '@utils/errorHandler';
import axios from 'axios';

export default function useFileDeleteHandler(props, onDeleteSuccess) {

    const isValidId = (id) => {
        return Number.isInteger(id);
    }

    const deletePhotoDB = async (id, fileName, source, src = null, type = null) => {
        let routeDeletePhotoFinal = props.routeDeletePhoto + '/' + id + '/' + fileName;
        if(src !== null) {
            routeDeletePhotoFinal += '/' + src;
        }
        try {
            //Send a POST request to the server
            const response = await axios.get(routeDeletePhotoFinal, {
                headers: {
                    'X-CSRF-TOKEN': props.csrf // Include CSRF token here
                }
            });
            //Handle response here
            if(response.status === 201) {
                const data = response.data;
                if(data.success === 1) {
                    // Call the callback function with the response
                    if (onDeleteSuccess && typeof onDeleteSuccess === 'function') {
                        onDeleteSuccess(source, type);
                    }
                } else {
                    return [];
                }
            } else {
                if(response.message) {
                    showErrorToast(response.message);
                }
            }

        } catch (error) {
            showErrorToast(handleErrorResponse(error));
            console.error('Submission error', error);
        }
    }

    const deletePhotoServer = async (src, source, type = null) => {
        const routeDeletePhotoFinal = '/admin/image-service/delete-image/' + src;
        try {
            //Send a POST request to the server
            const response = await axios.get(routeDeletePhotoFinal, {
                headers: {
                    'X-CSRF-TOKEN': props.csrf // Include CSRF token here
                }
            });
            //Handle response here
            if(response.status === 201) {
                const data = response.data;
                if(data.success === 1) {
                    // Call the callback function with the response
                    if (onDeleteSuccess && typeof onDeleteSuccess === 'function') {
                        onDeleteSuccess(source, type);
                    }
                } else {
                    return [];
                }
            } else {
                if(response.message) {
                    showErrorToast(response.message);
                }
            }

        } catch (error) {
            showErrorToast(handleErrorResponse(error));
            console.error('Submission error', error);
        }
    }
    const deleteFile = (id, fileName, source, src = null, type = null) => {
        if(!isValidId(id)) {
            if(id === null || typeof(id) === 'undefined') {
                if(src !== null) {
                    deletePhotoServer(src, source, type);
                } else {
                    onDeleteSuccess(source, type);
                }
                return false;
            }
            showErrorToast('Invalid ID');
            return false;
        }
        if(fileName === null) {
            showErrorToast('Invalid file name');
            return false;
        }
        deletePhotoDB(id, fileName, source, src, type);
    };


    return {
        deleteFile,
    }
}
